export function hasCompleteArguments({
  function: { arguments: args },
}: {
  function: { arguments: string };
}): boolean {
  if (args === '') return true;

  try {
    JSON.parse(args);
    return true;
  } catch {
    return false;
  }
}
